import React, { useRef, useEffect, useState } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';

import LoadingIndicator from '../common/LoadingIndicator';

import useSocialLogin from './useSocialLogin';

const LoginModal = ({ handleBooking, onClose, submitting, error, handleGuest }) => {
  const navigate = useNavigate();
  const location = useLocation();

  const OutsideClickRef = useRef(null);

  const { loginWithGoogle, loginWithFacebook } = useSocialLogin({ callback: handleBooking });
  useEffect(() => {
    document.addEventListener('mousedown', handleOutsideClick);
    return () => document.removeEventListener('mousedown', handleOutsideClick);
  });

  const handleOutsideClick = (e) => {
    if (OutsideClickRef.current && !OutsideClickRef.current.contains(e.target)) {
      onClose(false);
    }
  };

  const createGuestBooking = () => {
    handleGuest(true);
    !submitting && handleBooking();
  };

  return (
    <div className="modal">
      <div className="login-modal-content" ref={OutsideClickRef} >
        <LoadingIndicator loading={submitting} />
        <button type="button" onClick={() => onClose(false)} className="blank-button"><span className="iconify close-modal" data-icon="iconamoon:close-bold"></span></button>
        <div className='login-modal-inner-content'>
          <div>
            <p className="login-modal-title">هل ترغب بتسجيل الدخول قبل المتابعة؟</p>
            <p className="login-modal-text">يمكنك عن طريق تسجيل الدخول متابعة حجوزاتك وآخر العروض</p>
            <p className="simple_button inline" onClick={createGuestBooking}>المتابعة كضيف</p>
            {error && <p className='error centered'> <span className="iconify" data-icon="zondicons:exclamation-solid"></span> {error}
            </p>}
          </div>

          <div>
            <p>تسجيل الدخول بإستخدام</p>
            <div className='login-buttons'>
              <button
                className="button large-button"
                style={{ backgroundColor: '#01A394' }}
                onClick={handleBooking}
              ><span className="iconify" data-icon="tabler:mail-filled"></span> البريد الإلكتروني</button>
              <div className='vertical-line-separator'>
                <div></div>
                <p>او</p>
                <div></div>
              </div>
              <div className='social-login'>
                <button
                  className="button large-button"
                  onClick={loginWithGoogle}
                >
                  <span className="iconify" data-icon="bi:google"></span>
                  قوقل
                </button>
                <button
                  className="button large-button"
                  onClick={loginWithFacebook}
                >
                  <span className="iconify" data-icon="bi:facebook"></span>
                  فيسبوك
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>);
};

export default LoginModal;